/** This export is automatically generated */
export const gitHash = 'dad9c569';
